import {
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  Typography
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import { connect } from 'formik';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getErrorLabelForPath,
  getErrorLabelForPathObject
} from '../utils/form-utils';
import BuscadorPaginado from './BuscadorPaginado';
import InputWithFormik from './inputs/InputWithFormik';

const InputComponent = ({ inputRef, ...other }) => <div {...other} />;

const InputBuscadorPaginadoWithFormik = props => {
  const { formik, multiple = false } = props;
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const value =
    _.get(formik.values, props.name) === 0
      ? 0
      : _.get(formik.values, props.name) || '';
  let helperText = '';

  if (multiple) {
    helperText = getErrorLabelForPath(
      props.name,
      formik.touched,
      formik.errors,
      t
    );
  } else {
    helperText = getErrorLabelForPathObject(
      props.name,
      formik.touched,
      formik.errors,
      props.valueKey,
      t
    );
  }

  const onClick = (event, item) => {
    if (props.onClick) {
      event.stopPropagation();
      props.onClick(item);
    }
  };

  const onDeleteAll = event => {
    if (props.onDeleteAll && value?.length > 0) {
      event.stopPropagation();
      props.onDeleteAll();
    }
  };

  const onDelete = (event, item) => {
    event.stopPropagation();
    props.onDelete(item);
  };

  let inputProps;

  if (multiple) {
    inputProps = {
      style: { padding: 0 },
      children: (
        <Grid container>
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            className="MuiOutlinedInput-adornedStart"
            style={{ paddingTop: 4, paddingBottom: 4 }}
          >
            <IconButton name="formularios">
              <SearchIcon />
            </IconButton>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              style={{ flex: 1 }}
            >
              Buscar
            </Typography>
            {props.onDeleteAll &&
              value?.length > 0 && (
                <div style={{ paddingRight: 4 }}>
                  <IconButton
                    onClick={onDeleteAll}
                    name="formularios"
                    focusable={false}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              )}
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            onClick={event => {
              event.stopPropagation();
            }}
          >
            {/* <Divider orientation="horizontal"  /> */}
            <Divider variant="middle" />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            onClick={event => {
              event.stopPropagation();
            }}
          >
            {value?.length > 0 && (
              <List
                subheader={<ListSubheader>Seleccionados</ListSubheader>}
                dense={true}
                style={{ paddingLeft: 8 }}
              >
                {value ? (
                  value?.map(item => (
                    <ListItem
                      button={!!props.onClick}
                      key={item.id}
                      onClick={event => onClick(event, item)}
                    >
                      <ListItemIcon>
                        <CheckIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          props.labelText
                            ? props.labelText(item)
                            : item[props.labelKey || 'text'] || ''
                        }
                        secondary={
                          props.sublabelText
                            ? props.sublabelText(item)
                            : item[props.sublabelKey || 'text'] || ''
                        }
                      />
                      {props.onDelete && (
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={event => onDelete(event, item)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  ))
                ) : (
                  <></>
                )}
              </List>
            )}
          </Grid>
        </Grid>
      )
    };
  }

  return (
    <>
      {!multiple ? (
        <InputWithFormik
          required
          label={props.label}
          name={props.name}
          value={value[props.labelKey || 'text'] || ''}
          placeholder={props.placeholder}
          onClick={() => {
            setOpen(true);
          }}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            )
          }}
          helperText={helperText}
        />
      ) : (
        <>
          <InputWithFormik
            required
            label={props.label}
            name={props.name}
            value={''}
            placeholder={props.placeholder}
            onClick={() => {
              setOpen(true);
            }}
            InputProps={{
              readOnly: true,
              style: { padding: 0 },
              inputComponent: InputComponent
            }}
            helperText={helperText || ' '}
            inputProps={inputProps}
            multiline
            focused={false}
          />
        </>
      )}
      <BuscadorPaginado
        open={open}
        onOk={() => setOpen(false)}
        onClose={() => setOpen(false)}
        list={props.list}
        datosConfig={props.datosConfig}
        datosSettings={props.datosSettings}
        onReloadTable={props.onReloadTable}
        onItemClick={(event, item) => {
          if (props.onSelected) {
            props.onSelected(event, item);
            setOpen(false);
          }
        }}
        {...props}
      />
    </>
  );
};

export default connect(InputBuscadorPaginadoWithFormik);
